import { Button } from '@ibsys/kit';
import { InfoIcon } from 'lucide-react';
import { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMainLayout } from '@/shared/ui';
import { RuleInfoDialog } from './RuleInfoDialog';
import { RuleInfoPopup } from './RuleInfoPopup';
import { Position } from './useDraggablePosition';

/** Зазор между значком и открытой рядом с ним подсказкой */
const POPUP_GAP = 8;

/**
 * Значок «i» рядом с полем правила: по клику открывает справку по синтаксису
 * рядом с собой. Справка — не тултип, поэтому по наведению не показывается.
 */
export const RuleInfoButton: FC = () => {
  const { t } = useTranslation('attributes');
  const { isMobile } = useMainLayout();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [popupPosition, setPopupPosition] = useState<Position | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpen = () => {
    // На телефоне справка открывается обычным окном системы: перетаскивать её и тянуть за угол там нечем
    if (isMobile) {
      setIsDialogOpen(true);
      return;
    }
    const rect = buttonRef.current?.getBoundingClientRect();
    setPopupPosition({ x: (rect?.right ?? 0) + POPUP_GAP, y: rect?.top ?? POPUP_GAP });
  };

  const handleClose = () => setPopupPosition(null);

  const handleCloseDialog = () => setIsDialogOpen(false);

  return (
    <>
      <Button
        ref={buttonRef}
        variant="ghost"
        size="icon"
        className="size-6"
        aria-label={t('ruleInfo.open')}
        icon={<InfoIcon />}
        onClick={handleOpen}
      />
      {isDialogOpen && <RuleInfoDialog onClose={handleCloseDialog} />}
      {!isMobile && popupPosition && <RuleInfoPopup initialPosition={popupPosition} onClose={handleClose} />}
    </>
  );
};
